// extracted by mini-css-extract-plugin
module.exports = {"ElectricalAppliances":"ElectricalAppliances_ElectricalAppliances__MwNR_"};